<div class="mbm-card">
  <ng-content></ng-content>
</div>
